"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@unly/utils");
const i18next_1 = __importDefault(require("i18next"));
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const lodash_includes_1 = __importDefault(require("lodash.includes"));
const lodash_get_1 = __importDefault(require("lodash.get"));
const acceptLanguage_1 = __importDefault(require("./serverDetectors/acceptLanguage"));
const serverCookie_1 = __importDefault(require("./serverDetectors/serverCookie"));
const fallback_1 = __importDefault(require("./universalDetectors/fallback"));
exports.COOKIE_LOOKUP_KEY_LANG = 'i18next';
exports.universalLanguageDetect = (props) => {
    const { supportedLanguages, fallbackLanguage, acceptLanguageHeader = undefined, serverCookies = undefined, errorHandler = undefined, } = props;
    if (!lodash_get_1.default(supportedLanguages, 'length')) {
        throw new Error(`universal-language-detector is misconfigured. Your "supportedLanguages" should be an array containing at least one language (eg: ['en']).`);
    }
    if (!lodash_includes_1.default(supportedLanguages, fallbackLanguage)) {
        throw new Error(`universal-language-detector is misconfigured. Your "fallbackLanguage" (value: "${fallbackLanguage}") should be within your "supportedLanguages" array.`);
    }
    i18next_1.default.init({
        whitelist: supportedLanguages,
        nonExplicitWhitelist: true,
    });
    const i18nextServices = i18next_1.default.services;
    const i18nextUniversalLanguageDetector = new i18next_browser_languagedetector_1.default();
    const fallbackDetector = fallback_1.default(fallbackLanguage);
    i18nextUniversalLanguageDetector.addDetector(fallbackDetector);
    if (utils_1.isBrowser()) {
        i18nextUniversalLanguageDetector.init(i18nextServices, {
            order: ['cookie', 'navigator', fallbackDetector.name],
            lookupCookie: exports.COOKIE_LOOKUP_KEY_LANG,
        });
    }
    else {
        const serverCookieDetector = serverCookie_1.default(serverCookies);
        const acceptLanguageDetector = acceptLanguage_1.default(supportedLanguages, acceptLanguageHeader, errorHandler);
        i18nextUniversalLanguageDetector.addDetector(serverCookieDetector);
        i18nextUniversalLanguageDetector.addDetector(acceptLanguageDetector);
        i18nextUniversalLanguageDetector.init(i18nextServices, {
            order: [serverCookieDetector.name, acceptLanguageDetector.name, fallbackDetector.name],
            lookupCookie: exports.COOKIE_LOOKUP_KEY_LANG,
        });
    }
    return i18nextUniversalLanguageDetector.detect().split('-')[0];
};
exports.default = exports.universalLanguageDetect;
//# sourceMappingURL=index.js.map